import { supabase } from '../supabaseClient';

async function scheduledSiteVisit(scheduleData, leadId, cpId, userId,fosId) {
    if(cpId==='-'){
        cpId=null;
    }
    if(fosId==='-'){
        fosId=null;
    }
    const { data, error } = await supabase
        .from('ScheduleSiteVisit')
        .insert([{
           leadId: leadId, dateTime: scheduleData.dateTime, projectId: scheduleData.projectId,
            unitType: null, cpId: cpId,userId:userId,fosId:fosId

        }])
    if (data) return data;
    else throw error;
}
async function updateLeadStatus(leadId) {
    const { data, error } = await supabase
        .from('LeadStatus')
        .update({ status: 'Site Visit Scheduled',last_updated_at:Date.now() })
        .eq('leadId', leadId)
    if (data) return data;
    else throw error;
}
export { scheduledSiteVisit,updateLeadStatus }